import { delete0, get, post } from '@/utils/request'

const examApi = {
  // 科目接口
  examSubject: '/api/content/exam/subject',
  // 试题接口
  examQuestion: '/api/content/exam/question',
  // 试卷接口
  examPaper: '/api/content/exam/paper',
  // 测评管理接口
  examUser: '/api/content/exam/eval_user',
  // 测评接口
  examEval: '/api/content/exam/eval',
  // 阅卷接口
  examMark: '/api/content/exam/mark'
}

// *********************************************************************************************************************
// 科目接口
export function getSubject() {
  return get(examApi.examSubject)
}

export function getSubjectKV() {
  return get(examApi.examSubject + '/kv')
}

export function getSubjectCascade() {
  return get(examApi.examSubject + '/cascade')
}

// *********************************************************************************************************************
// 试题接口
export function getQuestionType() {
  return get(examApi.examQuestion + '/type')
}

export function getQuestions(queryParams) {
  return get(examApi.examQuestion + '/list', queryParams)
}

export function deleteQuestion(questionId) {
  return delete0(examApi.examQuestion + '/' + questionId)
}

export function getQuestion(questionId) {
  return get(examApi.examQuestion + '/' + questionId)
}

export function addQuestion(jsonData) {
  return post(examApi.examQuestion, jsonData)
}

// *********************************************************************************************************************
// 试卷接口
export function addPaper(jsonData) {
  return post(examApi.examPaper, jsonData)
}

export function deletePaper(paperId) {
  return delete0(examApi.examPaper + '/' + paperId)
}

export function getPapers(queryParams) {
  return get(examApi.examPaper, queryParams)
}

export function getPaper(queryParams) {
  return get(examApi.examPaper + '/detail', queryParams)
}

// *********************************************************************************************************************
// 测评用户接口
export function getCandidateUsers(queryParams) {
  return get(examApi.examUser + '/candidate', queryParams)
}

export function addEvalUsers(jsonData) {
  return post(examApi.examUser, jsonData)
}

export function getEvalUsers(queryParams) {
  return get(examApi.examUser, queryParams)
}

// *********************************************************************************************************************
// 测评接口
export function getExamList() {
  return get(examApi.examEval + '/list')
}

export function getExamInfo(queryParams) {
  return get(examApi.examEval + '/start', queryParams)
}

export function cacheUserAnswer(jsonData) {
  return post(examApi.examEval + '/cache', jsonData)
}

export function getCachedUserAnswer(queryParams) {
  return get(examApi.examEval + '/cache', queryParams)
}

export function submitExam(jsonData) {
  return post(examApi.examEval + '/submit', jsonData)
}

export function getExamResult(queryParams) {
  return get(examApi.examEval + '/result', queryParams)
}

// *********************************************************************************************************************
// 阅卷接口
export function getMarkPapers() {
  return get(examApi.examMark + '/paper')
}

export function getExamMarkList(queryParams) {
  return get(examApi.examMark + '/paper_list', queryParams)
}

export function getMarkView(queryParams) {
  return get(examApi.examMark + '/view', queryParams)
}

export function submitMarkResult(jsonData) {
  return post(examApi.examMark + '/submit', jsonData)
}

// *********************************************************************************************************************
// 测评数据接口
export function getExamCount() {
  return get('/api/content/exam/statistic/count')
}

export function getExamPassRate() {
  return get('/api/content/exam/statistic/rate')
}

export function getLineChartData() {
  return get('/api/content/exam/statistic/linechart')
}
